export class SearchResult {
    public description: string = '';
    public id: string = '';
    public page: number = 0;
}
